const sliders = () => {


	// слайдер на главной

	try {
		const mainSliderBlock = document.querySelector('[data-slider="main-slider"]');

		let mainSlider = new Swiper(mainSliderBlock, {
			loop: true,
			navigation: {
			    nextEl: '[data-btn="main-slider-next"]',
			    prevEl: '[data-btn="main-slider-prev"]',
		  	},
		  	pagination: {
			    el: '.slider-counter',
			    type: 'fraction',
			  },
		});
	} catch(e) {}

	//END слайдер на главной

	// быстрый подбор игл на главной

	try {
		const fastSelectNeedlesBlock = document.querySelector('[data-slider="fast-product-select"]');

		let fastSelectNeedles = new Swiper(fastSelectNeedlesBlock, {
			slidesPerView: 1,
			loop: false,
			navigation: {
			    nextEl: '[data-btn="filter-slide-next"]',
			    prevEl: '[data-btn="filter-slide-prev"]',
		  	},
		  	breakpoints: {
		  		440: {
		  			slidesPerView: 2,
		  		},
		  		1055: {
		  			slidesPerView: 3,
		  		},
		  		1220: {
		  			slidesPerView: 4,
		  		},
		  	}
		});
	} catch(e) {}

	//END быстрый подбор игл на главной

	// слайдер на главной спец предложения
	try {
		const actionProductsBlock = document.querySelector('[data-slider="actions-product"]');

		let actionProducts =  new Swiper(actionProductsBlock, {
			slidesPerView: 2,
			spaceBetween: 5,
			loop: false,
			navigation: {
			    nextEl: '[data-btn="action-prod-next"]',
			    prevEl: '[data-btn="action-prod-prev"]',
		  	},
		  	breakpoints: {
		  		610: {
		  			slidesPerView: 2,
		  			spaceBetween: 10,
		  		},
		  		800: {
		  			slidesPerView: 3,
		  		},
		  		1220: {
		  			slidesPerView: 4,
		  		},
		  	}
		});
	} catch(e) {}

	//END слайдер на главной спец предложения

	// слайдер на главной популярные товары
	try {
		const popularProductBlock = document.querySelector('[data-slider="popular-product"]');

		let popularProduct = new Swiper(popularProductBlock, {
			slidesPerView: 2,
			spaceBetween: 5,
			loop: false,
			navigation: {
			    nextEl: '[data-btn="popular-product-next"]',
			    prevEl: '[data-btn="popular-product-prev"]',
		  	},
		  	breakpoints: {
		  		610: {
		  			slidesPerView: 2,
		  			spaceBetween: 10,
		  		},
		  		800: {
		  			slidesPerView: 3,
		  			spaceBetween: 20,
		  		},
		  		1220: {
		  			slidesPerView: 4,
		  		}
		  	}
		});
	} catch(e) {}

	//END слайдер на главной популярные товары

	// слайдер на странице каталога

	try {
		const populatProductCatalogBlock = document.querySelector('[data-slider="popular-product_3-card"]');

		let popularProductCatalog = new Swiper(populatProductCatalogBlock, {
			slidesPerView: 2,
			spaceBetween: 20,
			loop: false,
			navigation: {
			    nextEl: '[data-btn="popular-product-next"]',
			    prevEl: '[data-btn="popular-product-prev"]',
		  	},
		  	breakpoints: {
		  		610: {
		  			slidesPerView: 2,
		  		},
		  		// 1055: {
		  		// 	slidesPerView: 2,
		  		// },
		  		1220: {
		  			slidesPerView: 3,
		  		}
		  	}
		});

	} catch(e) {}

	//END слайдер на странице каталога

	// слайдер в карточке товара
	try {
		const productCardSliderNavBlock = document.querySelector('[data-slider="nav-img-prod"]');
		const productCardSliderMainBlock = document.querySelector('[data-slider="main-img-slider"]');

		let productCardSliderNav = new Swiper(productCardSliderNavBlock, {
			spaceBetween: 10,
			navigation: {
			  nextEl: '[data-btn="next-slide"]',
			  prevEl: '[data-btn="prev-slide"]',
			},
			slidesPerView: 4,
			direction: 'vertical',
			freeMode: true,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			loop: false
		});

		let productCardSliderMain = new Swiper(productCardSliderMainBlock, {
			spaceBetween: 10,
			// navigation: {
			//   nextEl: '[data-btn="next-slide"]',
			//   prevEl: '[data-btn="prev-slide"]',
			// },
			thumbs: {
				swiper: productCardSliderNav
			},
			loop: false
		});

		// переключение слайда по клику на вариант упаковки
		const sliderBlock 		= document.querySelector('[data-block="slider-block"]'); //блок родитель
		const productSlidesArr 	= document.querySelectorAll('[data-slider="nav-img-prod"] .swiper-slide'); //массив слайдов на странице
		const productSlidesMain = document.querySelectorAll('[data-slider="main-img-slider"]'); //главный слайдер
		const productSlidesNav	= document.querySelectorAll('[data-slider="nav-img-prod"]'); //слайдер навигации

		//ставим на место главного фото выбранное из варианта упаковки
		if(productSlidesArr.length) {
			productSlidesArr.forEach((item, i) => {
				if(item.classList.contains('active')) {
					productCardSliderMain.slideTo(i);
				}
			});
		}
		

		sliderBlock.addEventListener('click', (e)=>{
			let target = e.target;
			let parentBlock;
			if(target.dataset.slideBtn || target.closest('.equipment-item')) {
				if(target.dataset.slideBtn) {
					parentBlock = target;
				} else if(target.closest('.equipment-item')) {
					parentBlock = target.closest('.equipment-item');
				}

				// активируем нужный слайд
				productSlidesArr.forEach((item, i) => {
					
					if(item.dataset.slide == parentBlock.dataset.slideBtn && !item.classList.contains('swiper-slide-duplicate')) {
						if(productCardSliderNav) {
							productCardSliderNav.slideTo(i);
						}
						if(productCardSliderMain) {
							productCardSliderMain.slideTo(i);
						}

						item.classList.add('active');
					} else {
						item.classList.remove('active');
					}
				});
			}
		});

	} catch(e){}
	//END слайдер в карточке товара

}	

export default sliders; 